// extracted by mini-css-extract-plugin
module.exports = {"bubble":"general__bubble__AUz+f"};